/**
 * status.ts
 * ----------------
 * UI data contracts for status-related components.
 */

import { ServiceState } from '../../constants/serviceStates';
import { LiveSiteEventSeverity } from '../status';

export interface ActiveLiveSiteEvent {
    geographies: string[];
    impactStartTimestampUtc: string;
    id: number;
    service: string;
    severity: LiveSiteEventSeverity;
    title:  string;
}

/**
 * Captures status details for a given geography.
 */
export interface GeographyStatusDetailRow {
    geography: string;
    lastUpdatedTimestamp: string | 'N/A';
    state: ServiceState;
}

export type TimeRangeValue = 'Last24Hours' | 'Last48Hours' | 'Last7Days' | 'Last30Days' | 'Last60Days' | 'Last90Days';

export const Last24Hours: TimeRangeValue = 'Last24Hours';
export const Last30Days: TimeRangeValue = 'Last30Days';
export const Last48Hours: TimeRangeValue = 'Last48Hours';
export const Last60Days: TimeRangeValue = 'Last60Days';
export const Last7Days: TimeRangeValue = 'Last7Days';
export const Last90Days: TimeRangeValue = 'Last90Days';
